exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-0745240c]{border-left:1px dashed #ccc;border-right:1px dashed #ccc;border-top:1px dashed #ccc}.layout-col[data-v-0745240c]{height:60px;width:100%;border-bottom:1px dashed #ccc;border-right:1px dashed #ccc;padding:6px;box-sizing:border-box;overflow:hidden}.layout-edit[data-v-0745240c]{width:100%;height:100%;outline:none;padding:10px;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-0745240c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/layout.vue
// module id = 78
// module chunks = 0